export default {
    default: {
        Benefits: "Benefits h-screen relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper w-full pl-25 absolute z-20 bottom-0 pb-29% lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle: ""
    },
    BeautyCoachBenefits: {
        Benefits: "BC-benefits Benefits h-screen relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "sm:text-center textWrapper w-full pl-25 absolute z-20 bottom-0 pb-29% lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    NDBenefits: {
        Benefits: "Benefits h-screen relative overflow-hidden NDBenefit",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper w-full pl-25 absolute z-20 bottom-0 pb-29% lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    xoxoBenefitPanel: {
        Benefits: "xoxoBenefitPanel Benefits relative overflow-hidden NDBenefit",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper pl-25 absolute z-20 lg:pr-80 lg:pl-0",
        title: "header3 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    GUBenefits: {
        Benefits: "Benefits relative overflow-hidden NDBenefit GUBenefit",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper w-full pl-25 pr-25 absolute z-20 bottom-0 pb-70 lg:pb-0 lg:top-0 lg:inset-y-auto lg:left-0 lg:pl-80 lg:pr-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 g:pb-12 lg:ml-15",
        description: "body-small mt-3% lg:mt-5% ",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    kokeshiBenefits: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-80 lg:pb-0 lg:mb-80 w-full",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body-small mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },    
    kokeshiSecondBenefits: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiSecondBenefits",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:left-auto lg:right-3/4 px-15 lg:ml-100 bottom-0 pb-50 w-full",
        title: "header3 lg:pr-0",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    //TrBenefitsCenterAlign: {
    TRCenterAlign: {
        Benefits: "TRCenter relative",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        //textWrapper: "text-center textWrapper z-20 absolute bottom-0 mb-110 lg:mb-0 lg:top-0 lg:left-0 w-full lg:flex lg:items-center lg:justify-center lg:flex-col overflow-hidden" ,
        //textWrapper: "text-center textWrapper z-20 absolute bottom-0 lg:bottom-100 mb-110 lg:mb-0 lg:top-0 lg:left-0 w-full overflow-hidden",
        textWrapper: "text-center textWrapper z-20 absolute bottom-110 lg:bottom-160 w-full",
        title: "header3 lg:pr-0",
        nameSection: "benefitNames header3 px-25",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-30",
        description: "body px-25",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3 w-full",
        black: "theme-black",
        white: "theme-white"
    },
    TRRightAlign: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-70 lg:pb-0 lg:mb-80 w-full",
        title: "header3 pr-25 lg:pr-0 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    TRGUERightAlign: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pl-55 px-15 bottom-0 top-80 lg:mt-230 min-h-480 pb-70 lg:pb-0 lg:mb-80 w-full",
        title: "header3 pr-25 lg:pr-0 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    }, 
    hainanBenifits: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-55 lg:pb-0 lg:mb-80 w-full",
        title: "header3 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    }, 
    CelebrityKv: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-50 lg:pb-0 lg:mb-80 w-full",
        title: "header3 lg:pr-0 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },  
    darkCircle: {
        Benefits: "Benefits relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen lg:h-710 absolute",
        video: "media absolute",
        textWrapper: "text-center darkCircle textWrapper w-full px-25 absolute z-20 bottom-0 pb-85 lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header3 mr-15 pb-10 lg:relative cursor-pointer lg:pb-12 lg:ml-0",
        description: "description body-small mt-3% pr-25 lg:pr-0 lg:pb-10 mx-auto",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle:""
    },
    gae: {
        Benefits: " gae Benefits relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen lg:h-710 absolute",
        video: "media absolute",
        textWrapper: "darkCircle textWrapper gae-hk w-full pl-25 absolute z-20 bottom-0 pb-30 lg:pb-0 lg:top-0 lg:inset-y-auto lg:pr-80 lg:pl-180 lg:flex lg:flex-col lg:justify-center text-center lg:text-left ",
        title: "header3 pr-25 lg:pr-0",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-15 lg:ml-0",
        description: "description body-small font-normal mt-3% pr-25 lg:mt-5% lg:pr-0 lg:absolute lg:bottom-30",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle: ""
    },
    guecCn: {
        Benefits: " gae Benefits relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen lg:h-710 absolute",
        video: "media absolute",
        textWrapper: "darkCircle textWrapper gae-hk w-full pl-25 absolute z-20 bottom-0 pb-30 lg:pb-0 lg:top-0 lg:inset-y-auto lg:pr-80 lg:pl-180 lg:flex lg:flex-col lg:justify-center text-center lg:text-left ",
        title: "header3 pr-25 lg:pr-0",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-15 lg:ml-0",
        description: "description body-small font-normal mt-3% pr-25 lg:mt-5% lg:pr-0 lg:relative lg:bottom-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle: ""
    }
}
